import { BuilderStoreContext } from "@builder.io/react";
import { Builder, BuilderElement } from "@builder.io/sdk";
import {
  TypographyTags,
  TypographyVariants,
} from "@faire/web--source/slate/Typography";
import React from "react";

import { tryEval } from "./__internal__/functions/try-eval";
import { CustomTypography } from "./CustomTypography";

export interface TextProps {
  text: string;
  variant?: TypographyVariants;
  as?: TypographyTags;
  color?: string;
  truncate?: boolean;
  maxLines?: number;
  builderBlock?: BuilderElement;
}

export class TextComponent extends React.Component<TextProps> {
  textRef: HTMLElement | null = null;

  componentDidMount() {
    // test if there are any expressions in text before assigning innerHTML
    if (this.textRef && !/{{([^}]+)}}/.test(this.props.text)) {
      this.textRef.innerHTML = this.props.text.replace(/<\/?p>/g, "");
    }
  }

  evalExpression = (expression: string, state: any) => {
    // Don't interpolate when inline editing
    if (this.allowTextEdit) {
      return String(expression).replace(/<\/?p>/g, "");
    }
    return String(expression)
      .replace(/{{([^}]+)}}/g, (_, group) => tryEval(group, state))
      .replace(/<\/?p>/g, "");
  };

  get allowTextEdit() {
    return (
      Builder.isBrowser &&
      Builder.isEditing &&
      location.search.includes("builder.allowTextEdit=true") &&
      !(
        this.props.builderBlock &&
        this.props.builderBlock.bindings &&
        (this.props.builderBlock.bindings["component.options.text"] ||
          this.props.builderBlock.bindings["options.text"] ||
          this.props.builderBlock.bindings["text"])
      )
    );
  }

  render() {
    return (
      <BuilderStoreContext.Consumer>
        {(state) => {
          return (
            <React.Fragment>
              <CustomTypography
                variant={this.props.variant}
                className={
                  /* NOTE: This class name must be "builder-text" for inline editing to work in the Builder editor */
                  "builder-text"
                }
                as={this.props.as}
                color={this.props.color}
                truncate={this.props.truncate}
                maxLines={this.props.maxLines}
                ref={(ref) => {
                  this.textRef = ref;
                }}
                dangerouslySetInnerHTML={{
                  __html: this.evalExpression(
                    this.props.text || (this.props as any).content || "",
                    state.state
                  ),
                }}
              />
            </React.Fragment>
          );
        }}
      </BuilderStoreContext.Consumer>
    );
  }
}
